export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-en-US.c94358be.xlsx";